module.exports = __webpack_public_path__ + "static/media/fax.f10db5bc.svg";